import React, { useEffect, useState } from "react";
import { Collapse, Form, Offcanvas, Spinner, Table } from "react-bootstrap";
import Moment from "react-moment";
import { NoDataFoundTable } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";

const SignatureReviewHistory = ({
  Show,
  Hide,
  Title,
  dataEntryReviewHistory,
  tableRef,
  onMouseDown,
  signedButtonLoader,
  signatureStudySubjectFormReviewFieldHistoryDataEntry,
  remark,
  setRemark,
  fieldId,
  formFields,
  totalDataEntry,
  setSelectedFields,
  selectedFields
}) => {
  const [openAction, setOpenAction] = useState(false);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  useEffect(() => {
    setOpenAction(false)
    setSelectedFields([])
    setRemark("")
  }, [Show]);

  let checkFieldData = formFields?.find(item => item.id === fieldId)
  let checkEntryStatus = totalDataEntry?.find(item => item.fieldId === fieldId)

  let fieldValue;
  if (checkFieldData?.type === "date") {
    fieldValue = `${checkEntryStatus?.day ?? ''}${checkEntryStatus?.month ? `-${checkEntryStatus.month}` : ''}${checkEntryStatus?.year ? `-${checkEntryStatus.year}` : ''}`;
  } else if (checkFieldData?.type === "time") {
    fieldValue = `${checkEntryStatus?.hour ?? ''}${checkEntryStatus?.minute ? `-${checkEntryStatus.minute}` : ''}${checkEntryStatus?.second ? `-${checkEntryStatus.second}` : ''} ${checkEntryStatus?.format ? `${checkEntryStatus.format}` : ''}`;
  } else if (checkFieldData?.type === "checkbox") {
    fieldValue = (checkEntryStatus?.value || [])?.map(item => item.value)?.join(", ")
  } else {
    fieldValue = checkEntryStatus?.value
  }

  const handleCheckboxChange = (e, name, label, value) => {
    const isChecked = e.target.checked;
    setSelectedFields(prev => {
      if (isChecked) {
        const alreadyExists = prev.some(item => item.name === name);
        if (!alreadyExists) {
          return [...prev, { name, label, value }];
        }
        return prev;
      } else {
        return prev.filter(item => item.name !== name);
      }
    });
  };

  let selectedDataFunction = () => {
    if (!(checkEntryStatus?.type.startsWith("custom") || checkFieldData?.fieldUnit === "yes" || checkFieldData?.customFieldRemark === "yes")) {
      setSelectedFields([{
        name: checkFieldData?.fieldName,
        label: checkFieldData?.fieldLabel,
        value: fieldValue
      }])
    }
  }

  useEffect(() => {
    selectedDataFunction()
  }, []);

  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end" style={{ width: '700px' }}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            {Title}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          {StudyMode?.startsWith("SDV") &&
            <div className="p-3">
              <div className="w-25">
                <button
                  onClick={() => { setOpenAction(!openAction); selectedDataFunction() }}
                  className={`updateProfile`}
                >
                  <span>Signature Now</span>
                </button>
              </div>
              <Collapse in={openAction === true}>
                <div>
                  <Form.Group style={{ textAlign: "justify", fontSize: 13 }} className="mt-2 mb-1">
                    <p className="br3 bg-primary-subtle p-2">
                      You are required to provide a signature for this activity in order
                      to fully complete it. This records that you are signing off theat
                      you have taken, and completed this online review activity. This
                      will resilt in the completion record being recorded in your review
                      history.
                    </p>
                  </Form.Group>
                  {(checkEntryStatus?.type.startsWith("custom") || checkFieldData?.fieldUnit === "yes" || checkFieldData?.customFieldRemark === "yes") &&
                    <Form.Group className="mb-1">
                      <Form.Label className="fw-bold mb-1">
                        Fields{" "}
                        <abbr title="Required" className="text-danger">
                          *
                        </abbr>
                      </Form.Label>
                      <Form.Check
                        type="checkbox"
                        label={`${checkFieldData?.fieldLabel} (${checkFieldData?.fieldName})`}
                        name="fieldLabel"
                        disabled={(checkEntryStatus?.reviewStatus === "yes") || (checkEntryStatus?.status !== "freezed") || (checkEntryStatus?.queryStatus === "open") || (checkEntryStatus?.queryNotifyStatus === "open")}
                        checked={selectedFields?.map(item => item.name)?.includes(checkFieldData?.fieldName)}
                        onChange={e => handleCheckboxChange(e, checkFieldData?.fieldName, checkFieldData?.fieldLabel, fieldValue)}
                      />
                      {(checkFieldData?.fieldUnit === "yes") && (
                        <Form.Check
                          type="checkbox"
                          label={`${checkFieldData?.fieldUnitLabel} (${checkFieldData?.fieldUnitName})`}
                          name="fieldUnitLabel"
                          disabled={(checkEntryStatus?.unitReviewStatus === "yes") || (checkEntryStatus?.unitStatus !== "freezed") || checkEntryStatus?.unitQueryStatus === "open" || checkEntryStatus?.unitQueryNotifyStatus === "open"}
                          checked={selectedFields?.map(item => item.name)?.includes(checkFieldData?.fieldUnitName)}
                          onChange={e => handleCheckboxChange(e, checkFieldData?.fieldUnitName, checkFieldData?.fieldUnitLabel, checkEntryStatus?.unit)}
                        />
                      )}
                      {(checkFieldData?.customFieldRemark === "yes") && (
                        <Form.Check
                          type="checkbox"
                          label={`${checkFieldData?.customFieldRemarkLabel} (${checkFieldData?.customFieldRemarkName})`}
                          name="customFieldRemarkLabel"
                          disabled={(checkEntryStatus?.reviewValueRemarkStatus === "yes") || (checkEntryStatus?.valueRemarkStatus !== "freezed") || checkEntryStatus?.queryValueRemarkStatus === "open" || checkEntryStatus?.queryValueRemarkNotifyStatus === "open"}
                          checked={selectedFields?.map(item => item.name)?.includes(checkFieldData?.customFieldRemarkName)}
                          onChange={e => handleCheckboxChange(e, checkFieldData?.customFieldRemarkName, checkFieldData?.customFieldRemarkLabel, checkEntryStatus?.valueRemark)}
                        />
                      )}
                      {checkEntryStatus?.type.startsWith("custom") &&
                        <>
                          {(checkFieldData?.referenceRangeLowerLimit === "yes") && (
                            <Form.Check
                              type="checkbox"
                              label={`${checkFieldData?.referenceRangeLowerLimitLabel} (${checkFieldData?.referenceRangeLowerLimitName})`}
                              name="referenceRangeLowerLimitLabel"
                              disabled={(checkEntryStatus?.referenceRangeLowerLimitReviewStatus === "yes") || (checkEntryStatus?.referenceRangeLowerLimitStatus !== "freezed") || checkEntryStatus?.referenceRangeLowerLimitQueryStatus === "open" || checkEntryStatus?.referenceRangeLowerLimitQueryNotifyStatus === "open"}
                              checked={selectedFields?.map(item => item.name)?.includes(checkFieldData?.referenceRangeLowerLimitName)}
                              onChange={e =>
                                handleCheckboxChange(e, checkFieldData?.referenceRangeLowerLimitName, checkFieldData?.referenceRangeLowerLimitLabel, checkEntryStatus?.referenceRangeLowerLimit)
                              }
                            />
                          )}
                          {(checkFieldData?.referenceRangeUpperLimit === "yes") && (
                            <Form.Check
                              type="checkbox"
                              label={`${checkFieldData?.referenceRangeUpperLimitLabel} (${checkFieldData?.referenceRangeUpperLimitName})`}
                              name="referenceRangeUpperLimitLabel"
                              disabled={(checkEntryStatus?.referenceRangeUpperLimitReviewStatus === "yes") || (checkEntryStatus?.referenceRangeUpperLimitStatus !== "freezed") || checkEntryStatus?.referenceRangeUpperLimitQueryStatus === "open" || checkEntryStatus?.referenceRangeUpperLimitQueryNotifyStatus === "open"}
                              checked={selectedFields?.map(item => item.name)?.includes(checkFieldData?.referenceRangeUpperLimitName)}
                              onChange={e =>
                                handleCheckboxChange(e, checkFieldData?.referenceRangeUpperLimitName, checkFieldData?.referenceRangeUpperLimitLabel, checkEntryStatus?.referenceRangeUpperLimit)
                              }
                            />
                          )}
                          {(checkFieldData?.referenceRangeIndicator === "yes") && (
                            <Form.Check
                              type="checkbox"
                              label={`${checkFieldData?.referenceRangeIndicatorLabel} (${checkFieldData?.referenceRangeIndicatorName})`}
                              name="referenceRangeIndicatorLabel"
                              disabled={(checkEntryStatus?.referenceRangeIndicatorReviewStatus === "yes") || (checkEntryStatus?.referenceRangeIndicatorStatus !== "freezed") || checkEntryStatus?.referenceRangeIndicatorQueryStatus === "open" || checkEntryStatus?.referenceRangeIndicatorQueryNotifyStatus === "open"}
                              checked={selectedFields?.map(item => item.name)?.includes(checkFieldData?.referenceRangeIndicatorName)}
                              onChange={e =>
                                handleCheckboxChange(e, checkFieldData?.referenceRangeIndicatorName, checkFieldData?.referenceRangeIndicatorLabel, checkEntryStatus?.referenceRangeIndicator)
                              }
                            />
                          )}
                          {(checkFieldData?.clinicalSignificance === "yes") && (
                            <Form.Check
                              type="checkbox"
                              label={`${checkFieldData?.clinicalSignificanceLabel} (${checkFieldData?.clinicalSignificanceName})`}
                              name="clinicalSignificanceLabel"
                              disabled={(checkEntryStatus?.clinicalSignificanceReviewStatus === "yes") || (checkEntryStatus?.clinicalSignificanceStatus !== "freezed") || checkEntryStatus?.clinicalSignificanceQueryStatus === "open" || checkEntryStatus?.clinicalSignificanceQueryNotifyStatus === "open"}
                              checked={selectedFields?.map(item => item.name)?.includes(checkFieldData?.clinicalSignificanceName)}
                              onChange={e =>
                                handleCheckboxChange(e, checkFieldData?.clinicalSignificanceName, checkFieldData?.clinicalSignificanceLabel, checkEntryStatus?.clinicalSignificance)
                              }
                            />
                          )}
                          {(checkFieldData?.customRemark === "yes") && (
                            <Form.Check
                              type="checkbox"
                              label={`${checkFieldData?.customRemarkLabel} (${checkFieldData?.customRemarkName})`}
                              name="customRemarkLabel"
                              disabled={(checkEntryStatus?.remarkReviewStatus === "yes") || (checkEntryStatus?.remarkStatus !== "freezed") || checkEntryStatus?.remarkQueryStatus === "open" || checkEntryStatus?.remarkQueryNotifyStatus === "open"}
                              checked={selectedFields?.map(item => item.name)?.includes(checkFieldData?.customRemarkName)}
                              onChange={e =>
                                handleCheckboxChange(e, checkFieldData?.customRemarkName, checkFieldData?.customRemarkLabel, checkEntryStatus?.remark)
                              }
                            />
                          )}
                        </>
                      }
                    </Form.Group>
                  }
                  <Form.Group className="mb-1">
                    <Form.Label className="fw-bold mb-1">
                      Remark{" "}
                      <abbr title="Required" className="text-danger">
                        *
                      </abbr>
                    </Form.Label>
                    {(checkEntryStatus?.type.startsWith("custom") || checkFieldData?.fieldUnit === "yes" || checkFieldData?.customFieldRemark === "yes") ?
                      <Form.Control
                        onChange={(e) => setRemark(e.target.value)}
                        value={remark}
                        className="br3"
                        placeholder="Remark"
                        as="textarea"
                      />
                      :
                      <Form.Control
                        onChange={(e) => setRemark(e.target.value)}
                        value={remark}
                        disabled={(checkEntryStatus?.reviewStatus === "yes") || (checkEntryStatus?.status !== "freezed") || (checkEntryStatus?.queryStatus === "open")}
                        className="br3"
                        placeholder="Remark"
                        as="textarea"
                      />
                    }
                  </Form.Group>
                  <div className="text-end">
                    <button
                      disabled={!remark || selectedFields?.length === 0 || signedButtonLoader}
                      onClick={signatureStudySubjectFormReviewFieldHistoryDataEntry}
                      className="updateProfile"
                    >
                      {signedButtonLoader ? (
                        <div className="hstack gap-2">
                          <Spinner size="sm"/> Signing...
                        </div>
                      ) : (
                        "Sign Field"
                      )}
                    </button>
                  </div>
                </div>
              </Collapse>
            </div>
          }
          {(dataEntryReviewHistory?.length === 0 && !StudyMode?.startsWith("SDV")) ?
            <div className="hstack justify-content-center h-100">
              <NoDataFoundTable MSG={"Signature review history not found!"} />
            </div>
            : dataEntryReviewHistory?.length > 0 &&
            <Table ref={tableRef} className="m-0 custom-table" hover striped>
              <thead className="position-sticky top-0 z-1">
                <tr>
                  <th
                    onMouseDown={(e) => onMouseDown(e, 0)}
                    style={{ width: 45 }}
                    className="text-center"
                  >
                    Sr.
                  </th>
                  <th style={{ width: 120 }} onMouseDown={(e) => onMouseDown(e, 1)}>Field Name</th>
                  <th onMouseDown={(e) => onMouseDown(e, 2)}>Field Value</th>
                  <th style={{ width: 80 }} onMouseDown={(e) => onMouseDown(e, 3)}>Status</th>
                  <th onMouseDown={(e) => onMouseDown(e, 4)}>Remark</th>
                  <th style={{ width: 120 }} onMouseDown={(e) => onMouseDown(e, 5)}>Reviewed By</th>
                  <th style={{ width: 120 }} onMouseDown={(e) => onMouseDown(e, 6)}>Date | Time</th>
                </tr>
              </thead>
              <tbody>
                {dataEntryReviewHistory?.map((item, index) => (
                  <tr key={index}>
                    <td className="text-center">{index + 1}.</td>
                    <td title={item.fieldLabel}>{item.fieldName}</td>
                    <td>
                      {checkFieldData?.type === "checkbox" ? (
                        (item?.fieldValue || '')
                          .split(', ')
                          .map((el, index) => (
                            <React.Fragment key={index}>
                              {el},
                              <br />
                            </React.Fragment>
                          ))
                      ) : (
                        item?.fieldValue
                      )}
                    </td>
                    <td className="text-capitalize">{item?.status}</td>
                    <td>{item?.remark}</td>
                    <td>{item?.reviewedBy}</td>
                    <td>
                      <Moment format="DD MMM YYYY | HH:mm" withTitle>
                        {item.createdAt}
                      </Moment>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          }
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default SignatureReviewHistory;